
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    Compatibility: () => import("@/components/Compatibility.vue")
  }
})
export default class AreYouSure extends Vue {
  active_tab = 1;
  form = {
    checked: []
  };

  showModal() {
    (this.$refs["areyousure"] as any).show();
  }

  hideModal() {
    (this.$refs["areyousure"] as any).hide();
  }
}
